import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/splide.min.css';

class Slider {
    constructor(node) {
        this.node = node;
        this.lightboxNode = node.closest('.columns')?.querySelector('.splide--popup');

        this.slider = null;
        this.lightboxSlider = null;

        this.initSlider();
    }

    initSlider() {
        const { node, lightboxNode } = this;
        this.slider = new Splide(node, {
            perPage: 1,
            perMove: 1,
            autoplay: true,
            interval: 2500,
            pauseOnHover: true,
            type: 'fade',
            pagination: false,
            arrows: true,
        });

        if (lightboxNode) {
            this.lightboxSlider = new Splide(lightboxNode, {
                perPage: 1,
                perMove: 1,
                type: 'fade',
                pagination: false,
                arrows: true,
            });
        }

        this.slider.mount();

        if (this.lightboxSlider) {
            this.lightboxSlider.mount();

            let fromPopup = false;

            this.slider.on('moved', (index) => {
                if (fromPopup) return;
                this.lightboxSlider.go(index);
            });

            this.lightboxSlider.on('moved', (index) => {
                fromPopup = true;
                this.slider.go(index);

                setTimeout(() => {
                    fromPopup = false;
                }, 10);
            });

            lightboxNode.addEventListener('mouseenter', (e) => {
                this.slider.Components.Autoplay.pause();
            });

            lightboxNode.addEventListener('mouseleave', (e) => {
                this.slider.Components.Autoplay.play();
            });
        }
    }

    static init() {
        const sliders = document.querySelectorAll('.splide:not(.splide--popup');
        if (!sliders) return;

        sliders.forEach((slider) => {
            new Slider(slider);
        });
    }
}

export default Slider;
